import type { Product } from "../../../__generated__/graphql";
import { StoreCardForTimesail } from "../../../components/store-card/store-card-for-timesail";
import { StoreCardForPack } from "../../../components/store-card/store-card-for-pack";
import { StoreCardForTimesailYet } from "../../../components/store-card/store-card-for-timesail-yet";
import {
  getReserveTime,
  getReserveTimeForTomorrow,
} from "../../../utils/reserve-time";
import { getExposeType, canPackExpose } from "../../../utils/store-expose";
import type { LikedStoreItem } from "../hooks/use-infinite-scroll-liked-stores";

interface LikedStoreListProps {
  allStores: LikedStoreItem[];
  loading: boolean;
  initLoading: boolean;
  onClickStore: (store: LikedStoreItem, type: string) => void;
  onClickLike: (
    storeId: number,
    isLiked: boolean | null,
    storeTitle?: string
  ) => Promise<void>;
}

export default function LikedStoreList({
  allStores,
  loading,
  initLoading,
  onClickStore,
  onClickLike,
}: LikedStoreListProps) {
  if (initLoading || loading) {
    return null;
  }

  return (
    <div className="mb-4">
      {allStores.map((store) => {
        if (!store) return null;
        if (
          store.todaysProducts?.length !== 0 &&
          !store.isProductAllSoldOut
        ) {
          return (
            <div key={store.id} className="mb-4">
              <StoreCardForTimesail
                title={store.title}
                products={store.todaysProducts as Product[]}
                closingHours={(store.closingHours ?? "") as string}
                discountPrice={
                  (store.todaysProducts as Product[])?.[0]?.userPrice ?? null
                }
                price={(store.todaysProducts as Product[])?.[0]?.price ?? null}
                distance={store.distance}
                img={(store.img ?? "") as string}
                onClick={() => onClickStore(store, "실시간팩")}
                signupDate={store.createdAt}
              />
            </div>
          );
        }
        if (store.pack && canPackExpose(store)) {
          return (
            <div key={store.id} className="mb-4">
              <StoreCardForPack
                title={store.title}
                quantity={store.pack.currentCount ?? 0}
                discountPrice={store.pack.userPrice ?? 0}
                price={store.pack.price ?? 0}
                isLiked={store.isLiked}
                distance={store.distance}
                img={(store.img ?? "") as string}
                reserveTime={getReserveTime(store.reserveTime)}
                tomorrowReserveTime={getReserveTimeForTomorrow(store.reserveTime)}
                onClick={() => onClickStore(store, "예약팩")}
                onClickHeart={async (e) => {
                  e.stopPropagation();
                  await onClickLike(
                    store.id,
                    store.isLiked ?? null,
                    store.title
                  );
                }}
                exposeType={getExposeType(store.pack)}
                signupDate={store.createdAt}
              />
            </div>
          );
        }
        return (
          <div key={store.id} className="mb-4">
            <StoreCardForTimesailYet
              title={store.title}
              closingHours={(store.closingHours ?? "") as string}
              distance={store.distance}
              img={(store.img ?? "") as string}
              quantity={0}
              onClick={() => onClickStore(store, "기본")}
              onClickHeart={async (e) => {
                e.stopPropagation();
                await onClickLike(
                  store.id,
                  store.isLiked ?? null,
                  store.title
                );
              }}
              signupDate={store.createdAt}
            />
          </div>
        );
      })}
    </div>
  );
}
